import { createI18n } from 'vue-i18n'
import { useI18n } from 'vue-i18n'
import pl from './locales/pl.json'
import en from './locales/en.json'
import { Language } from '@/api/contracts/models'

type MessageSchema = typeof pl
type SupportedLanguages = `${Language}`

function polishPluralRule(choice: number): number {
  if (choice === 1) return 0

  const lastDigit = choice % 10
  const lastTwoDigits = choice % 100

  if (
    lastDigit >= 2 &&
    lastDigit <= 4 &&
    !(lastTwoDigits >= 12 && lastTwoDigits <= 14)
  ) {
    return 1
  }

  return 2
}

export function useInternationalization() {
  return createI18n<[MessageSchema], SupportedLanguages>({
    legacy: false,
    locale: 'PL',
    fallbackLocale: 'EN',
    messages: {
      PL: pl,
      EN: en,
      DE: en,
    },
    pluralRules: {
      PL: polishPluralRule,
    },
  })
}

export function useTranslations() {
  const { t } = useI18n<[MessageSchema]>()
  return { t }
}
